import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import API_URL from "../config";
import InputContrasena from "./InputContrasena";

function RecuperarContrasena2() {
    const [status, setStatus] = useState(null);
    const [error, setError] = useState("");
    const [passwordNueva, setPasswordNueva] = useState("");
    const [passwordConfirm, setPasswordConfirm] = useState("");
    const location = useLocation();
    const navigate = useNavigate();

    const token = new URLSearchParams(location.search).get("token");

    // Validar token al cargar (primer paso)
    useEffect(() => {
        fetch(`${API_URL}/recuperar_contrasena_2.php?token=${token}`)
            .then(res => res.json())
            .then(data => {
                if (data.status === "ok") {
                    setStatus("valid");
                } else {
                    setError(data.message || "Token inválido o expirado");
                }
            })
            .catch(() => setError("Error de conexión con el servidor"));
    }, [token]);

    // Enviar nueva contraseña
    const handleSubmit = async (e) => {
        e.preventDefault();

        // Validación de características de la contraseña
        const regexPassword = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[\W_]).{8,}$/;

        if (!regexPassword.test(passwordNueva)) {
            setError("La contraseña debe tener mínimo 8 caracteres, incluir mayúscula, minúscula, número y carácter especial.");
            setTimeout(() => setError(""), 3000);
            return;
        }

        // Confirmación de contraseña
        if (passwordNueva !== passwordConfirm) {
            setError("Las contraseñas no coinciden");
            setTimeout(() => setError(""), 2000);
            return;
        }

        try {
            console.log(token); // Línea de prueba
            console.log("Payload enviado:", { token, contrasena_nueva: passwordNueva }); // Línea de apoyo
            const res = await fetch(`${API_URL}/cambiar_contrasena_token.php`, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ token, contrasena_nueva: passwordNueva })
            });
            const data = await res.json();
            if (data.status === "ok") {
                setStatus("changed");
            } else {
                setError(data.message || "Error al cambiar la contraseña");
                setTimeout(() => setError(""), 2000);
            }
        } catch {
            setError("Error de conexión con el servidor");
            setTimeout(() => setError(""), 2000);
        }
    };

    // Renderizado según estado
    if (error) return <div className="error">{error}</div>;
    if (status === "changed") {
        setTimeout(() => {
            navigate("/login");
        }, 3000);

        return <div className="success">Contraseña cambiada correctamente</div>;
    }

    return (
        <div className="sesion-form">
            {status === "valid" && (
                <form onSubmit={handleSubmit}>

                    <InputContrasena
                        contrasena={passwordNueva}
                        setContrasena={setPasswordNueva}
                        label="Nueva contraseña"
                    />

                    <InputContrasena
                        contrasena={passwordConfirm}
                        setContrasena={setPasswordConfirm}
                        label="Confirmar contraseña"
                    />

                    <button type="submit">Cambiar contraseña</button>
                </form>
            )}
            {status === null && <div>Cargando...</div>}
        </div>
    );
}

export default RecuperarContrasena2;